import { EventBus } from '@/event-bus'
import events from '@/core/events/events'

export const utils = {
  enableSaveButton(enableSaveButton) {
    if (enableSaveButton) {
      EventBus.$emit(events.APPROVAL_RULE.ENABLE_SAVE_BUTTON)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/_modules/Approvals/Approval-rule/approvalRuleUtils.js